import styles from "./Dashboard.module.scss";
import { useState } from "react";
import { useDashboardStore } from "@/shared/stores/dashboardStore";
import type { StatCategory } from "./types";

export function CategorySelector({
  categories,
  isMobile,
}: {
  categories: StatCategory[];
  isMobile: boolean;
}) {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const { activeCategory, setActiveCategory } = useDashboardStore();

  if (isMobile) {
    return (
      <div className={styles.dropdown}>
        <button
          className={styles.dropdownButton}
          onClick={() => setDropdownOpen((s) => !s)}
        >
          {activeCategory}
          <svg
            className={`${styles.dropdownIcon} ${isDropdownOpen ? styles.open : ""}`}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 9L12 15L18 9"
              stroke="#3C91E6"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        {isDropdownOpen && (
          <div className={styles.dropdownMenu}>
            {categories.map((cat) => (
              <button
                key={cat}
                className={`${styles.dropdownItem} ${activeCategory === cat ? styles.active : ""}`}
                onClick={() => {
                  setActiveCategory(cat);
                  setDropdownOpen(false);
                }}
              >
                {cat}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.categories}>
      {categories.map((cat) => (
        <button
          key={cat}
          className={`${styles.categoryButton} ${activeCategory === cat ? styles.active : ""}`}
          onClick={() => setActiveCategory(cat)}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}
